import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { BsArrowDownCircle } from 'react-icons/bs';
import moment from 'moment';
import { Table, ComboBox } from 'components';
import { getColumns } from './columns';
import ApiServices from 'services';
import storage from 'storage';
import Utils from 'commons/utils';
import { ContainerHeader, ButtonExport } from './styles';
import { debounce } from 'lodash';
import { CLIENT_STATUS_ID, CLIENT_STATUS_NAME } from 'commons/constants';
import { ChangeSupporterForm } from './change-supporter';
import { Popup } from 'components';
import PopupUserSupervisor from 'views/client-holding/popups/popup-user-supervisor';

const DEFAULT_FILTER = {
  pageNumber: 1,
  pageSize: 10,
};

export function LeadsFailedList() {
  const { LEADS_FAILED, NEAR_LEAD } = CLIENT_STATUS_ID;

  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [selectedChangeSupporter, setSelectedChangeSupporter] = useState(null);

  const [searchSuspensionDate, setSearchSuspensionDate] = useState(null);
  const [searchFoundingDate, setSearchFoundingDate] = useState(null);

  const [operatorList, setOperatorList] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState([]);

  //#region Nhan-sm added
  const [dataMainUserById, setDataMainUserById] = React.useState([]);
  const [clientCareHistoryItem, setClientCareHistoryItem] = React.useState({});

  const fetchOperators = async () => {
    try {
      const res = await ApiServices.getOperators();
      console.log(res?.data);
      setOperatorList(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const getListByPositionId = async (position, idClientCareHistory = '') => {
    try {
      const { data } = await ApiServices.getListByPositionId(position, idClientCareHistory);
      if (data && idClientCareHistory) {
        setDataMainUserById(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getClientCareHistoryDetails = async (idClientCareHistory) => {
    try {
      const { data } = await ApiServices.getClientCareHistoryDetails(idClientCareHistory);
      setClientCareHistoryItem(data);
      await getListByPositionId('admin', data.id);
    } catch (error) {
      console.error('Error fetching client details:', error);
    }
  };
  //endregion

  const initData = (query) => {
    setLoading(true);
    return ApiServices.getLeadsFailedList(LEADS_FAILED, query ? query : filter)
      .then((res) => {
        if (res?.data) {
          if (totalRecords !== res?.data?.totalRecords) setTotalRecords(res?.data?.totalRecords);
          setClients(res?.data?.data || []);
        }
      })
      .catch((err) => console.warn('get Client Trash:', err))
      .finally(() => setLoading(false));
  };

  const handleSearchColumn = (event) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };
      const { value, name } = event.target;
      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };
  const handleSearchColumnDate = (value, name) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };

      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };

  const handleSearchDataArray = (value, name) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };

      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };

  useEffect(() => {
    fetchOperators();
  }, []);

  const timeoutGetData = useCallback(
    debounce((newFilter) => {
      initData(newFilter);
    }, 500),
    [],
  );
  useEffect(() => {
    timeoutGetData(filter);
  }, [filter]);

  const reloadData = async () => {
    return await initData(filter);
  };

  const handleChangeOperator = useCallback(
    (_, newValue) => {
      console.log(newValue);
      setOperatorSelected(newValue || []);

      const operatorCodes = newValue?.map((item) => item.code).join(' ');
      handleSearchDataArray(operatorCodes, 'listOperator.code');
    },
    [operatorSelected],
  );

  const handleChangeSearchSuspensionDate = (event) => {
    const date = event.target.value;
    setSearchSuspensionDate(date);

    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    handleSearchColumnDate(dateSearch, 'ObjClientCompanyPause.SuspensionDate');
  };

  const handleChangeSearchFoundingDate = (event) => {
    const date = event.target.value;
    setSearchFoundingDate(date);

    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    handleSearchColumnDate(dateSearch, 'objClientCompany.foundingDate');
  };

  function onCloseChangeSupporter() {
    setSelectedChangeSupporter(null);
  }

  const handleChangeSupporter = async (row) => {
    setSelectedChangeSupporter(row);
    await getClientCareHistoryDetails(row.id);
  };

  const handleTakeCareAgain = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.updateClientStatus(row?.id, NEAR_LEAD);
      if (res?.data) {
        window.UIMessage?.success('Cập nhật thành công');
        reloadData();
      }
    } catch (error) {
      console.log('Change Status failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleExportClientTrash = async (dataOperator) => {
    const dataOperatorSelected = dataOperator?.map((item) => item.code);

    try {
      setLoading(true);

      const res = await ApiServices.exportExcel_TamNgung_New(dataOperatorSelected, {
        ClientStatusId: LEADS_FAILED,
      });

      if (res?.data) {
        Utils.exportTemplate(
          res?.data,
          `DS_Leads_That_Bai_${Utils.formatSimpleDate(moment())}.xlsx`,
        );
      }
    } catch (error) {
      console.error(error);
      console.log('Export Client Company error:', error);
      window.UIMessage?.error('Tải thất bại !!!');
    } finally {
      setLoading(false);
    }

    // setLoading(true);
    // await ApiServices.exportExcel_TamNgung_New({
    //   ClientStatusId: LEADS_FAILED,
    // })
    //   .then((res) => {
    //     if (res?.data) {
    //       Utils.exportTemplate(
    //         res?.data,
    //         `DS_Leads_That_Bai_${Utils.formatSimpleDate(moment())}.xlsx`,
    //       );
    //     }
    //   })
    //   .catch((err) => {
    //     console.log('Export Tempalte error:', err);
    //     window.UIMessage?.error('Tải thất bại !!!');
    //   });
    // setLoading(false);
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Leads thất bại
        </Typography>
      </ContainerHeader>

      <Box sx={{ width: '40%' }}>
        <ComboBox
          multiple
          disableCloseOnSelect
          options={operatorList}
          label="Đơn vị vận hành"
          sx={{ width: '100%' }}
          keyField="code"
          isOptionEqualToValue={(option, value) =>
            Boolean(option?.code) && option.code === value?.code
          }
          value={operatorSelected}
          onChange={handleChangeOperator}
        />
      </Box>

      <ButtonExport
        variant="outlined"
        startIcon={<BsArrowDownCircle />}
        onClick={() => handleExportClientTrash(operatorSelected)}
      >
        Tải excel
      </ButtonExport>
    </>
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          filter={filter}
          rows={clients}
          headCells={getColumns(
            handleSearchColumn,
            handleTakeCareAgain,
            handleChangeSupporter,
            searchSuspensionDate,
            handleChangeSearchSuspensionDate,
            searchFoundingDate,
            handleChangeSearchFoundingDate,
          )}
          totalRecords={totalRecords}
          onPageChange={(paging) => {
            setFilter((prev) => ({ ...prev, ...paging }));
          }}
          loading={loading}
          renderHeader={renderHeader}
        />
        {/* <ModalFormDetail
          maxWidth="sm"
          title="Thông tin Người phụ trách"
          open={!!selectedChangeSupporter}
          onCloseModal={onCloseChangeSupporter}
        >
          <ChangeSupporterForm dataSelected={selectedChangeSupporter} />
        </ModalFormDetail> */}

        <Popup
          title="Thông tin người phụ trách"
          open={Boolean(selectedChangeSupporter?.id)}
          closePopup={() => setSelectedChangeSupporter(false)}
          body={
            <PopupUserSupervisor
              clientCareHistoryItem={clientCareHistoryItem}
              getClientCareHistoryDetails={getClientCareHistoryDetails}
              dataMainUserById={dataMainUserById}
              setDataMainUserById={setDataMainUserById}
            />
          }
        />
      </Box>
    </>
  );
}
